import { React, useState, useContext, useEffect } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  addMonthsToDateString,
  getFormattedDate, isEndDateGreater,
  changeDateFormat, getMonthRange,
} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { getGroupSubGroupExcleReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';
import { generateOrnamentReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';


function RuralConsumerOrnamentsReport() {
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [reportType, setReportType] = useState('');
  const storedLanguage = localStorage.getItem('language');
  const today = new Date();
  const config = getAuthHeaders();

  useEffect(() => {

    setYears(getAllYears());
  }, []);



  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };

  //get Years 
  const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2001; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };



  const handleGenerateExcel = () => {

    if (reportType === '') {
      toast.error('Please select Report Type', messages.COLOR_RED);
      return
    }

    if (yearName === '') {
      toast.error('Please select Year Name', messages.COLOR_RED);
      return
    }


    let post_data = {
      reportType: reportType,
      year: yearName
    }

    showLoading(true)
    // POST request to API
    axios
      .post(`${API_URL}api/price/priRuralornamntsReports`, post_data, config)
      .then((response) => {
        const reportData = response.data.data.GroupCodes;
       let excelFileName = `PriRuralConsumerItem_${reportType}_${yearName}`;


        const excelObjectData = {
          fileName: excelFileName,
          reportType: excelFileName,
          fileType: 'xls',
          sheetName: "pre_rural_consumer_item",
          firstRowMergeCells: "A1:Q1",
          firstRowExportDate: changeDateFormat(new Date()),
          firstRowCellNumber: 12,
          secondRowMergeCells: "A2:Q2",
          secondRowText: `कृषि क्रय  विक्रय समता सूचकांक हेतु कुछ चुने हुए जिलों से ग्रामीण फुटकर भाव - ग्रामीण मजदूरी दरें -\n (Base Year 2011-12=100)`,
          thirdRowMergeCells: "A3:Q3",
          thirdRowText: `(${yearName}-${parseInt(yearName) + 1})`,
          headerHindiColumns: reportType === 'silver' 
          ? ['मद', '', `चांदी प्रति किलो`, '', '', '', '', '', '', '', '', '', '', '', '', '', '']
          : ['मद', '', `सोना प्रति 10 ग्राम`, '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
          headerHindiColumns2: [
            'क्रम स0', 'जनपद', 'प्रतिशत', 'जुलाई', 'अगस्त', `सितम्बर`, 'अक्टूबर', 'नवम्बर', 'दिसम्बर', 'जनवरी',
            'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'औसत कृषि वर्ष', 'भारित औसत'
          ],
          headerHindiColumns3: [
            '', '', '', `${yearName}`, `${yearName}`, `${yearName}`, `${yearName}`, `${yearName}`, `${yearName}`, `${parseInt(yearName) + 1}`,
            `${parseInt(yearName) + 1}`, `${parseInt(yearName) + 1}`, `${parseInt(yearName) + 1}`, `${parseInt(yearName) + 1}`, `${parseInt(yearName) + 1}`, `${parseInt(yearName) + 1}`, `${parseInt(yearName) + 1}`
          ],
          headerHindiColumns4: [
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17'
          ]

        };

        const transformedData = reportData.map((item, index) => [
          index + 1,
          item.col1,
          item.col2,
          item.col3,
          item.col4,
          item.col5,
          item.col6,
          item.col7,
          item.col8,
          item.col9,
          item.col10,
          item.col11,
          item.col12,
          item.col13,
          item.col14,
          item.col15,
          item.col16,

        ]);

        excelObjectData.excelRowData = transformedData;
        generateOrnamentReport(excelObjectData)
    })
      .catch((error) => {

        console.error('API Error', error);
      })
      .finally(() => {

        showLoading(false)
      })

  };


  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.RURAL_CONSUMER_ORNAMENTS_REPORT : priceTitle.en.RURAL_CONSUMER_ORNAMENTS_REPORT }} />

              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                    Select Year
                  </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={(e) => (setYearName(e.target.value))}
                    value={yearName}
                  >
                    <option value="" disabled> Select Year </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {getNextYear(ele)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label> Select Report</label>

                  <select
                    name="report_type"
                    className="form-select"
                    onChange={(e) => (setReportType(e.target.value))}
                    value={reportType}
                  >
                    <option value="" disabled>[---Select--]</option>
                    <option value="silver">Silver</option>
                    <option value="gold">Gold</option>
                  </select>

                </div>

                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RuralConsumerOrnamentsReport